import type { AppRouteObject } from "../routes";
import { UserFederationRoute } from "./routes/UserFederation";

const routes: AppRouteObject[] = [
  UserFederationRoute,

];

export default routes;
